//@flow
import { type DropdownOption } from './types';

export const filterOptions = (initialArr: string[]): DropdownOption[] =>
  initialArr.map(x => ({
    text: x.replace('_', ' '),
    value: x
  }));
